import { z } from 'zod'

// Login form schema
export const loginSchema = z.object({
  login: z.string().min(1, 'validation.loginRequired'),
  password: z.string().min(1, 'validation.passwordRequired'),
  rememberMe: z.boolean(),
})

// Forgot password form schema
export const forgotPasswordSchema = z.object({
  email: z.email('validation.emailRequired'),
})

// Reset password form schema
export const resetPasswordSchema = z
  .object({
    password: z.string().min(8, 'errors.passwordTooWeak'),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'errors.passwordMismatch',
    path: ['confirmPassword'],
  })

// Type exports
export type LoginFormData = z.infer<typeof loginSchema>
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>